import {
    SET_CAPSULE_LOADING,
    RESET_CAPSULE_STATE,
    GET_CAPSULES_SUCCESS,
    GET_CAPSULES_FAIL,
    GET_MOOC_CAPSULES_SUCCESS,
    GET_MOOC_CAPSULES_FAIL,
    GET_CAPSULE_SUCCESS,
    GET_CAPSULE_FAIL,
    CREATE_CAPSULE_REQUEST,
    CREATE_CAPSULE_SUCCESS,
    CREATE_CAPSULE_FAIL,
    UPDATE_CAPSULE_REQUEST,
    UPDATE_CAPSULE_SUCCESS,
    UPDATE_CAPSULE_FAIL,
    DELETE_CAPSULE_REQUEST,
    DELETE_CAPSULE_SUCCESS,
    DELETE_CAPSULE_FAIL,
    GET_DOMAINES_SUCCESS,
    GET_DOMAINES_FAIL,
    GET_THEMES_BY_DOMAINE_REQUEST,
    GET_THEMES_BY_DOMAINE_SUCCESS,
    GET_THEMES_BY_DOMAINE_FAIL,
} from "../actions/capsuleActions";

const initialState = {
    loading: false,
    error: null,
    success: false,
    lastAction: null,
    capsules: [],
    moocCapsules: [],
    selectedCapsule: null,
    domaines: [],
    themes: [],
};

const mergeCapsule = (capsules, payload) => {
    const list = Array.isArray(capsules) ? capsules : [];
    if (!payload?.id) return list;
    let found = false;
    const next = list.map((item) => {
        if (item.id !== payload.id) return item;
        found = true;
        return { ...item, ...payload };
    });
    return found ? next : [payload, ...next];
};

export default function capsuleReducer(state = initialState, action) {
    switch (action.type) {
        case SET_CAPSULE_LOADING:
            return { ...state, loading: Boolean(action.payload) };

        case RESET_CAPSULE_STATE:
            return { ...state, error: null, success: false, lastAction: null };

        case CREATE_CAPSULE_REQUEST:
        case UPDATE_CAPSULE_REQUEST:
        case DELETE_CAPSULE_REQUEST:
            return { ...state, loading: true, error: null, success: false, lastAction: null };

        case GET_CAPSULES_SUCCESS:
            return { ...state, loading: false, capsules: Array.isArray(action.payload) ? action.payload : [], error: null };

        case GET_MOOC_CAPSULES_SUCCESS:
            return { ...state, loading: false, moocCapsules: Array.isArray(action.payload) ? action.payload : [], error: null };

        case GET_CAPSULE_SUCCESS:
            return { ...state, loading: false, selectedCapsule: action.payload || null, error: null };

        case CREATE_CAPSULE_SUCCESS:
            return {
                ...state,
                loading: false,
                capsules: action.payload ? [action.payload, ...(state.capsules || [])] : state.capsules,
                success: true,
                lastAction: "create",
                error: null,
            };

        case UPDATE_CAPSULE_SUCCESS:
            return {
                ...state,
                loading: false,
                capsules: mergeCapsule(state.capsules, action.payload),
                success: true,
                lastAction: "update",
                error: null,
            };

        case DELETE_CAPSULE_SUCCESS:
            return {
                ...state,
                loading: false,
                capsules: (state.capsules || []).filter((item) => item.id !== action.payload),
                success: true,
                lastAction: "delete",
                error: null,
            };

        case GET_DOMAINES_SUCCESS:
            return { ...state, domaines: Array.isArray(action.payload) ? action.payload : [], error: null };

        case GET_THEMES_BY_DOMAINE_REQUEST:
            return { ...state, themes: [], error: null };

        case GET_THEMES_BY_DOMAINE_SUCCESS:
            return { ...state, themes: Array.isArray(action.payload) ? action.payload : [], error: null };

        case GET_CAPSULES_FAIL:
        case GET_MOOC_CAPSULES_FAIL:
        case GET_CAPSULE_FAIL:
        case CREATE_CAPSULE_FAIL:
        case UPDATE_CAPSULE_FAIL:
        case DELETE_CAPSULE_FAIL:
        case GET_DOMAINES_FAIL:
        case GET_THEMES_BY_DOMAINE_FAIL:
            return { ...state, loading: false, error: action.payload || "Erreur", success: false, lastAction: null };

        default:
            return state;
    }
}
